// extracted by mini-css-extract-plugin
module.exports = {"Container":"PayoutsList_Container__2j5hL","Heading":"PayoutsList_Heading__1HjzP"};